export default "__VITE_ASSET__CgILoAEJ__"